import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { GasTableComponent } from '../gas-table/gas-table.component';
import { GasTable } from '../gas-table.namespace';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr [gasSelectableTableHeadRow]',
  templateUrl: `./gas-selectable-table-head-row.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasSelectableTableHeadRowComponent {

  @Input()
  public disableRowSelectionFilter: ((rowData: Record<string, unknown>) => boolean) | undefined;

  public get isSelectableRow(): boolean {
    return this.gasTableComponent.selectionMode !== GasTable.TableRowsSelectionMode.None;
  }

  public get isMultipleSelectionMode(): boolean {
    return this.gasTableComponent.selectionMode === GasTable.TableRowsSelectionMode.Multiple;
  }

  constructor(
    private gasTableComponent: GasTableComponent,
  ) { }

}
